import Vue from 'vue';
import Vuex from 'vuex';
import { BlueSearch } from '@/search/lib/blue-search.js';
import store from "@/search/store/index";
// import '@/search/lib/scss/main.scss';
import App from './src/search/App.vue';

window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('#search-app');
  const options = { ...el.dataset };

  Vue.config.productionTip = false;
  Vue.use(Vuex);
  Vue.use(BlueSearch, options);

  new Vue({
    store: new Vuex.Store(store),
    render: h => h(App),
  }).$mount(el);
});
